<template>
  <b-sidebar
    id="sidebar-send-email"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Envoyé {{ data.name }}</h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- Body -->
      <b-form class="p-2" @submit.prevent>
        <!-- From -->
        <b-form-group label="From" label-for="from">
          <b-form-input
            id="from"
            v-model="sendData.from"
            trim
            type="email"
            disabled
          />
        </b-form-group>

        <!-- To -->
        <b-form-group label="To" label-for="to">
          <b-form-input
            id="to"
            v-model="sendData.to"
            trim
            type="email"
            :value="data.email"
          />
        </b-form-group>

        <!-- Subject -->
        <b-form-group label="Subject" label-for="subject">
          <b-form-input id="subject" v-model="sendData.subject" trim />
        </b-form-group>

        <!-- Message -->
        <b-form-group label="Message" label-for="message">
          <b-form-textarea
            id="message"
            v-model="sendData.message"
            rows="12"
            trim
          />
        </b-form-group>

        <!-- ? File/Attachement -->
        <b-badge variant="light-primary">
          <feather-icon icon="LinkIcon" />
          <span class="ml-50">{{ data.name }}</span>
        </b-badge>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="sendEmail()"
          >
            Envoyé
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="hide"
          >
            Fermer
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton,
  BBadge,
} from "bootstrap-vue";
import { ref } from "@vue/composition-api";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BBadge,
  },
  props: {
    data: { type: Object },
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      sendData: {
        from: "test.user@gmail.com",
        to: this.data.email,
        subject: "Devis #" + this.data.code,
        message: "lorem lorem lorem lorem lorem lorem lorem",
      },
    };
  },
  methods: {
    sendEmail() {
      // axios
      //   .post(
      //     "https://management-projects.herokuapp.com/api/quotes/",sendData
      //   )
      //   .then((response) => {
      //    this.$toast({
      //   component: ToastificationContent,
      //      props: {
      //     title: "Email bien envoyé",
      //     icon: "EditIcon",
      //     variant: "info",
      //    },
      //   });
      //   })
      //   .catch((error) => {
      //     this.errorMessage = error.message;
      //   });
    },
  },
  //   setup() {
  //     const sendData = ref({
  //       from: "shelbyComapny@email.com",
  //       to: "",
  //       subject: "Invoice of purchased Admin Templates",
  //       message: `Dear Queen Consolidated,

  // Thank you for your business, always a pleasure to work with you!

  // We have generated a new invoice in the amount of $95.59

  // We would appreciate payment of this invoice by 05/11/2019`,
  //       // ? Need to handle how you want to send item
  //       // * You can also send link to download invoice in message
  //     });

  //     return {
  //       sendData,
  //     };
  //   },
};
</script>

<style>
</style>
